import { schemeTableau10 } from 'd3-scale-chromatic'

// Add the Monomer color as the first color.
export const D3_SCALE_ORDINAL = [
  '#14919B', // accent-dark
  ...schemeTableau10,
]
